import { TServerErrorResponse } from "@/types";
import { links } from "@/constants";
import { PhoneNumber } from "../../types/phone-number";
import { http } from "@/api/httpHandler";

export const PHONE_NUMBER_USER_LIST_GET = "phone-number-user-list-get";
export const getUserPhoneNumbers = async (
  userId?: string,
): Promise<PhoneNumber[]> => {
  if (!userId) return [];
  try {
    const response = await http.get<PhoneNumber[]>(
      links.phoneNumber.phoneNumberList(userId),
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const createUserPhoneNumber = async (
  userId: string,
  number: string,
  extension: string | undefined = undefined,
) => {
  try {
    const response = await http.post<PhoneNumber>(links.phoneNumber.index, {
      number,
      userId,
      extension,
    });

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const removePhoneNumber = async (id: string) => {
  try {
    await http.delete(links.phoneNumber.phoneNumberById(id));
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
